import React from 'react';
import cn from 'classnames';
import orderBy from 'lodash/orderBy';

import { useDeepEqualSelector } from 'Shared/utils/hooks';
import AvatarsOfMembers from 'Shared/components/AvatarsOfMembers/AvatarsOfMembers';

import { getUsersWhoPresenceOnItem } from './utils';
import './UserPresenceInWorkspaceItem.scss';

type Props = {
  itemUuid: string;
};

function UserPresenceInWorkspaceItem({ itemUuid }: Props) {
  const presentUsers = useDeepEqualSelector(state =>
    getUsersWhoPresenceOnItem({
      presenceData: state.workspace.presenceData,
      currentUserId: state.user.id,
      itemUuid,
    })
  );
  const workspaceMembers = useDeepEqualSelector(state => state.workspace.users);
  const presentUsersFromWorkspaceMembers = presentUsers
    .map(({ userId, active }) => ({
      ...workspaceMembers.find(({ id }) => id === userId),
      active,
    }))
    .filter(({ id }) => id);
  const inactiveUsersIds = presentUsers.filter(({ active }) => !active).map(({ userId }) => userId);

  return (
    <AvatarsOfMembers
      members={orderBy(presentUsersFromWorkspaceMembers, 'active', 'desc')}
      inactiveUsersIds={inactiveUsersIds}
      className={cn('workspace-item-user-presence cursor-default position-absolute px-2', {
        'workspace-item-user-presence--one-user': presentUsersFromWorkspaceMembers.length === 1,
        'workspace-item-user-presence--two-users': presentUsersFromWorkspaceMembers.length === 2,
        'workspace-item-user-presence--more-three-users': presentUsersFromWorkspaceMembers.length >= 3,
      })}
      additionalLabelForTooltip={` ${presentUsers.length > 1 ? 'are' : 'is'} viewing now`}
    />
  );
}

export default React.memo(UserPresenceInWorkspaceItem);
